import { getTokens } from "./identity";
import { API } from "./index";

export const authForAdmin = async () => {
  const tokens = getTokens();
  if (tokens) {
    try {
      const response = await API.get("/api/v1/admin/auth", {
        headers: {
          Authorization: `Bearer ${tokens.accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Admin auth failed", error);
    }
  }
};

export const adminCampaignCall = async () => {
  const tokens = getTokens();
  if (tokens) {
    try {
      const response = await API.get("/api/v1/admin/campaign-call", {
        headers: {
          Authorization: `Bearer ${tokens.accessToken}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
};

export const adminApiStats = async () => {
  const tokens = getTokens();
  if (tokens) {
    try {
      const response = await API.get("/api/v1/admin/api-stats", {
        headers: {
          Authorization: `Bearer ${tokens.accessToken}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
};
